import TextInput from "Components/TextInput/TextInput";
import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { languages } from "lib/data";
import DropdownInput from "Components/DropDownInput/DropDownInput";
import { Tooltip, TooltipContent, TooltipTrigger } from "Components/ui/tooltip";
import { Skeleton } from "Components/ui/skeleton";
import UseInnerWidth from "hooks/UseInnerWidth";
import { useAuth } from "@clerk/clerk-react";
import { editUser } from "../../../../Redux/Profile/ProfileActions";
import { Button } from "Components/ui/button";

function AccountInfo({ data, setData }) {
  const { user, getUserLoading } = useSelector((state) => state.ProfileReducer);

  useEffect(() => {
    setData({
      nickName: user?.nickName,
      timezone: -1 * (new Date()?.getTimezoneOffset() / 60),
      language: user?.language,
    });
  }, [user]);

  const width = UseInnerWidth();
  const { getToken } = useAuth();
  const dispatch = useDispatch();

  return (
    <AnimatePresence initial={true} mode="wait">
      <motion.form
        exit={{
          opacity: 0,
          x: -100,
        }}
        initial={{
          opacity: 0,
          x: -100,
        }}
        animate={{
          opacity: 1,
          x: 0,
        }}
        className="bg-background-card rounded-lg p-8 grid grid-cols-1 gap-6"
      >
        {getUserLoading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <div className="space-y-2" key={i}>
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-10 w-full  rounded-md" />
            </div>
          ))
        ) : (
          <>
            <TextInput
              label="Nickname"
              required={true}
              placeholder="JohnDoe_TheTrader"
              type="text"
              value={data.nickName}
              onChange={(e) => setData({ ...data, nickName: e.target.value })}
            />
            <TextInput
              label="Timezone"
              required={true}
              placeholder="GMT+3"
              type="text"
              disabled
              value={`GMT${
                new Date()?.getTimezoneOffset() <= 0 ? "+" : "-"
              }${Math.abs(new Date()?.getTimezoneOffset() / 60)}`}
              onChange={(e) => setData({ ...data, timezone: e.target.value })}
            />
            <DropdownInput
              label={"Language"}
              required={true}
              placeholder={"Select Language"}
              value={data.language}
              setValue={(value) => setData({ ...data, language: value })}
              data={languages}
              key={"languages"}
            />

            <Button
              className={`${width >= 768 && "col-span-full ml-[auto]"}   mt-4`}
              type="button"
              disabled={
                !(
                  data?.nickName !== user?.nickName ||
                  data?.timezone !== Number(user?.timezone) ||
                  data?.language !== user?.language
                )
              }
              onClick={() =>
                dispatch(
                  editUser(
                    {
                      nickName: data?.nickName,
                      timezone: data?.timezone,
                      language: data?.language,
                    },
                    getToken
                  )
                )
              }
            >
              Save Changes
            </Button>
          </>
        )}
      </motion.form>
    </AnimatePresence>
  );
}

export default AccountInfo;
